import React, { useMemo } from 'react'
import { Field } from '@workwhile/ui'
import { ListDocument } from 'api/user/uploadI9Document'
import {
  DocumentTitles,
  DocumentType,
  ListA,
  ListB,
  ListC,
  Supplementary,
} from './constants'

const getOptionFromDocumentType = (type: DocumentType) => ({
  label: DocumentTitles[type],
  value: type,
})

const listAOptions = ListA.map(getOptionFromDocumentType)
const listBOptions = ListB.map(getOptionFromDocumentType)
const listCOptions = ListC.map(getOptionFromDocumentType)
const supplementaryOptions = Supplementary.map(getOptionFromDocumentType)

const OptGroup = (group: {
  label: string
  options: ReturnType<typeof getOptionFromDocumentType>[]
}) => (
  <optgroup key={group.label} label={group.label}>
    {group.options.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))}
  </optgroup>
)

export const DocumentTypeSelector = ({
  documents,
  error,
  onChange,
  value,
}: {
  documents: ListDocument[]
  error?: string
  onChange: (value: DocumentType) => void
  value: DocumentType | null
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange((e.target.value as DocumentType) || null)
  }

  const showList: Partial<Record<ListDocument['listType'], boolean>> = useMemo(
    () => ({
      A: !documents.some((document) => ['B', 'C'].includes(document.listType)),
      B: !documents.some((document) => ['A', 'B'].includes(document.listType)),
      C: !documents.some((document) => ['A', 'C'].includes(document.listType)),
      Supplementary: documents.length > 0,
    }),
    [documents]
  )

  return (
    <Field label="Document Type" error={error}>
      <select
        value={value || ''}
        onChange={handleChange}
        style={{
          width: '100%',
          padding: '8px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          fontSize: '14px',
        }}
      >
        <option value="">Select document type...</option>
        {showList.A ? (
          <OptGroup
            label="LIST A - Documents that Establish Both Identity and Employment Authorization"
            options={listAOptions}
          />
        ) : null}
        {showList.B ? (
          <OptGroup
            label="LIST B - Documents that Establish Identity"
            options={listBOptions}
          />
        ) : null}
        {showList.C ? (
          <OptGroup
            label="LIST C - Documents that Establish Employment Authorization"
            options={listCOptions}
          />
        ) : null}
        {showList.Supplementary ? (
          <OptGroup
            label="SUPPLEMENTARY - Documents that extend or validate list documents"
            options={supplementaryOptions}
          />
        ) : null}
      </select>
    </Field>
  )
}
